module.exports = __webpack_public_path__ + "img/46.9615bb0f.jpg";